import { Button, colors } from '@casavo/base-ui'
import cn from 'classnames'
import { motion } from 'framer-motion'
import useTranslation from 'next-translate/useTranslation'
import React, { MutableRefObject } from 'react'

import Phone from '@/components/Icon/Phone'
import Tap from '@/components/Icon/Tap'
import { RequestContactCTA } from '@/components/RequestContactCTA'
import { ButtonLink } from '@/design-lib/components/ButtonLink'
import { ListingCate } from '@/page-commons/listingBySlug'
import { getPreviousHourViews } from '@/utils/fomo-helper'
import { isThirdParty } from '@/utils/listing/listingType'
import { isLocaleEnabledFor } from '@/utils/locale-variables'

import FomoMessage from '../FomoMessage'

import { mobileButtonWrapper, motionDiv, motionP } from './styles.css'

const MobileButtons: React.FC<{
  handleOpenDetailFormModal: (reopenMap: boolean) => (event: React.SyntheticEvent<HTMLElement>) => void
  handleTrackingCallAgency: (et: string) => void
  inView: boolean
  property: ListingCate
  similarPropertiesRef: MutableRefObject<HTMLDivElement>
}> = ({ handleOpenDetailFormModal, handleTrackingCallAgency, inView, property, similarPropertiesRef }) => {
  const { lang, t } = useTranslation()
  const userViews = getPreviousHourViews(property.id)
  const thirdParty = isThirdParty(property)
  const isPropriooListing = property.country === 'france'
  const listingTitle = property.detail.titles.find((title) => title.language === lang).text

  return (
    <motion.div
      animate={{ y: 0 }}
      className={motionDiv}
      initial={{ y: '100%' }}
      transition={{ duration: 0.3, type: 'tween' }}
    >
      {!inView && (
        <>
          {isLocaleEnabledFor('fomo', lang) && (
            <motion.p animate={{ opacity: 1 }} className={motionP} initial={{ opacity: 0 }}>
              <FomoMessage userViews={userViews} />
            </motion.p>
          )}

          <div
            className={cn(mobileButtonWrapper, 'mobile-contact-us__button-wrapper')}
            data-testid="mobile-buttons-wrapper"
          >
            {thirdParty && (
              <>
                {!isPropriooListing && (
                  <ButtonLink
                    center
                    fullWidth
                    data-testid="telephone-number-dial"
                    href={`tel:${property.contactInfo.telephoneNumberContact}`}
                    Icon={(props) => <Phone {...props} color={colors.greyscale600} height={20} width={20} />}
                    label={t('listing-detail:phone_call')}
                    sizeVariant="small"
                    styleVariant="secondary"
                    onClick={() => {
                      handleTrackingCallAgency('ListingDetail')
                    }}
                  />
                )}
                <Button
                  data-testid="contact-form-button"
                  Icon={(props) => <Tap {...props} />}
                  label={t('listing-detail:request_call')}
                  sizeVariant="small"
                  styleVariant="primary"
                  onClick={handleOpenDetailFormModal(false)}
                />
              </>
            )}
            {!thirdParty && (
              <>
                <RequestContactCTA
                  isMobile
                  listing={property}
                  listingTitle={listingTitle}
                  requestType="info"
                  similarPropertiesRef={similarPropertiesRef}
                />
                <RequestContactCTA
                  isMobile
                  data-testid="request-visit-button"
                  listing={property}
                  listingTitle={listingTitle}
                  requestType="visit"
                  similarPropertiesRef={similarPropertiesRef}
                />
              </>
            )}
          </div>
        </>
      )}
    </motion.div>
  )
}

export default MobileButtons
